// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"styles_topContainer__1cXiq","secondaryIcon":"styles_secondaryIcon__1sVuT"};